import { useState, useRef, useEffect, ReactNode } from "react";
import { HiOutlineDotsVertical } from "react-icons/hi";

interface DropdownMenuProps {
  children: ReactNode;
}

export default function DropdownMenu({ children }: DropdownMenuProps) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => setOpen((prev) => !prev);

  // Close menu when clicking outside, but not when clicking inside a modal
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      // Check if the click target is within the dropdown menu itself
      if (menuRef.current && menuRef.current.contains(e.target as Node)) {
        return; // Don't close if click is inside the dropdown
      }
      
      // Check if the click target is within a modal
      const isClickInsideModal = (e.target as HTMLElement).closest('.modal-content');
      if (isClickInsideModal) {
        return; // Don't close if click is inside a modal
      }

      // Otherwise, close the dropdown
      setOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={menuRef}>
      <button
        onClick={toggleMenu}
        className="p-2 rounded-full hover:bg-gray-100 focus:outline-none"
      >
        <HiOutlineDotsVertical className="h-5 w-5" />
      </button>

      {open && (
        <div
          className="absolute right-0 mt-2 w-48 rounded-xl bg-white shadow-lg ring-1 ring-black/5 z-50 animate-fade-in"
        >
          <div className="py-1">{children}</div>
        </div>
      )}
    </div>
  );
}